import {
  AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE,
  AUTH_BACKUP_CODE_LENGTH,
  AUTH_CODE_ERROR_LENGTH_OR_TYPE,
  AUTH_CODE_LENGTH,
  AUTH_RECOVERY_CODE_LENGTH,
  OTP_RECOVERY_CODE_ERROR_LENGTH_OR_TYPE,
} from 'common/constants/auth';

export const constraints = {
  otp: {
    length: { minimum: AUTH_CODE_LENGTH, maximum: AUTH_CODE_LENGTH, message: AUTH_CODE_ERROR_LENGTH_OR_TYPE },
    format: {
      pattern: new RegExp(String.raw`^\d{${AUTH_CODE_LENGTH}}$`),
      message: AUTH_CODE_ERROR_LENGTH_OR_TYPE,
    },
  },
};

export const constraintsBkCode = {
  backupCode: {
    length: {
      minimum: AUTH_BACKUP_CODE_LENGTH,
      message: AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE,
      maximum: AUTH_BACKUP_CODE_LENGTH,
    },
    format: {
      pattern: new RegExp(`^[a-z2-7]{${AUTH_BACKUP_CODE_LENGTH}}$`),
      message: AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE,
    },
  },
};

export const constraintsRecoveryCode = {
  recoveryCode: {
    length: {
      minimum: AUTH_RECOVERY_CODE_LENGTH,
      maximum: AUTH_RECOVERY_CODE_LENGTH,
      message: OTP_RECOVERY_CODE_ERROR_LENGTH_OR_TYPE,
    },
    format: {
      pattern: new RegExp(String.raw`^\d{${AUTH_RECOVERY_CODE_LENGTH}}$`),
      message: OTP_RECOVERY_CODE_ERROR_LENGTH_OR_TYPE,
    },
  },
};
